module.exports = __webpack_public_path__ + "img/ct-point-of-connection.cc5e846e.png";